const serviceData = [
  {
    imgUrl:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fweb_application.webp?alt=media",
    altImg:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fweb_application.png?alt=media",
    tags: "Services",
    id: 3001,
    subscriptionType: 3,
    price: 0,
    serviceType: "Custom Application Development",
    name: "Web Application",
    description:
      "A web application is a software or program which is accessible using any web browser. Its frontend is usually created using languages like HTML, CSS, Javascript, which are supported by major browsers. While the backend could use any programming stack like LAMP, MEAN, etc.",
    features: ` <ul> Overview  <li> Our stack is VueJs + Firebase for frontend </li><li>PHP/JAVA/Python for middlewares</li><li>Mysql/Mariadb as databses.Contact Us for more.</li></ul>`
  },
  {
    imgUrl:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fmobile_application.webp?alt=media",
    altImg:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fmobile_application.png?alt=media",
    tags: "Services",
    id: 3002,
    subscriptionType: 3,
    price: 0,
    serviceType: "Custom Application Development",
    name: "Hybrid Application (Web and Mobile)",
    description:
      "A hybrid app is one that is written with the same technology used for websites and mobile web implementations, and that is hosted or runs inside a native container on a mobile device. It is the marriage of web technology and native execution.",
    features: `<ul> Overview  <li> Our stack is Nativescript+VueJs + Firebase for frontend </li><li>PHP/JAVA/Python for middlewares.Contact Us for more</li><li>Mysql/Mariadb as databses</li></ul>`
  },
  {
    imgUrl:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fcustom_features.webp?alt=media",
    altImg:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fcustom_features.png?alt=media",
    tags: "Services",
    id: 3003,
    subscriptionType: 3,
    price: 0,
    serviceType: "Custom Application Development",
    name: "Custom Features",
    description: "Do you need to develop a custom feature for your website?",
    features: `<ul> Overview  <li> We build custom features/plugins for wordpress/woocommerce/static /dynamic websites.Contact Us for more</li></ul>`
  },
  {
    imgUrl:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fshared_hosting.webp?alt=media",
    altImg:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Fshared_hosting.png?alt=media",
    tags: "Services",
    id: 3004,
    price: 1,
    INR: 999,
    USD: 15,
    subscriptionType: 2,
    serviceType: "Hosting",
    name: "Shared Hosting",
    description:
      "Shared hosting is one of the most popular hosting options for those who are building out their first websites.Shared hosting allows multiple websites to utilize a single server.Shared hosting is easily the cheapest and most economical option for your needs. However, the cheap price comes with limitations.",
    features: ` <ul> Overview  <li> Perfect for people who are just building their online presence </li> <li> Upto 3k visitors per month  </li> <li>We store our server in six different locations around the globe,so please choose your nearest location for max speed. </li></ul>`
  },
  {
    imgUrl:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Ffirebase_hosting.webp?alt=media",
    altImg:
      "https://firebasestorage.googleapis.com/v0/b/saascadetech-com.appspot.com/o/services%2Ffirebase_hosting.png?alt=media",
    tags: "Services",
    id: 3005,
    price: 1,
    INR: 1499,
    USD: 19,
    subscriptionType: 3,
    serviceType: "Hosting",
    name: "Firebase/Netlify Hosting",
    description:
      "Firebase Hosting provides fast and secure hosting for your web app, static and dynamic content, and microservices.",
    features: ` <ul> Overview  <li> We will deploy your apps/static websites in firebase/netlify.  </li><li> Applicable only for static websites and not for CMS like wordpress</li><li> Free lifetime hosting on google's cloud servers guaranteeing you the fastest response times</li></ul>`
  }
];
module.exports = serviceData;
